import DefaultSlider from './default-gallery'
import BlockSlider from './blocks-gallery'
import FeaturedContentSlider from './featured-content'
import ShowPostsGroupSlider from './show-posts-group'
import ProductInfusionMultipleSlider from './product-infusion-multiple'
import ModalGalleryArticle from '../modal-gallery/article'
import PromoBanner from './promo-banner'
import ListProductsSlider from './list-products-slider'
import VeterinaryAuthors from './veterinary-authors'
import EditorsPickHome from './editors-pick-home'
import ExpertsPicksHome from './experts-picks-grid-home'
import FeaturedContentHome from './featured-content-home'
import VetstreetSlideshow from './vetstreet-slideshow'
import CareTools from './care-credit-care-tools'

export default function () {
  const sliderConditions = [
    document.querySelectorAll(
      '.ArticleContent .tns-outer:not(.wp-block-product-infusion-block-product-infusion-multiple .tns-outer)'
    ).length > 0,
    document.querySelectorAll(
      `.ArticleContent__entry .blocks-gallery-grid,
      .PageMain--heat-giveaway .HeatGiveaway__images-slider .blocks-gallery-grid,
      .ArticleContent__entry .wp-block-gallery,
      .PageMain--heat-giveaway .HeatGiveaway__images-slider .wp-block-gallery`
    ).length > 0,
    document.querySelectorAll('.single-post .gallery').length > 0,
    document.querySelectorAll(
      '.FeaturedContent .tns-gallery:not(.ArticleContent .FeaturedContent .tns-gallery, .PageMain--great-pet-picks .FeaturedContentTop .tns-gallery, .PageMain--home .FeaturedContent--home .tns-gallery)'
    ).length > 0,
    document.querySelectorAll('.ArticleContent .FeaturedContent .tns-gallery')
      .length > 0,
    document.querySelectorAll(
      '.PageMain--home .FeaturedContent--home .tns-gallery'
    ).length > 0,
    document.querySelectorAll(
      '.PageMain--article .ArticleContent__entry .wp-block-product-infusion-block-product-infusion-multiple .ProductInfusionMultiple'
    ).length > 0,
    document.querySelectorAll('.PostsGroup__list .tns-gallery').length > 0,
    document.querySelectorAll(
      '.PromoBannerSlider .blocks-gallery-grid, .PromoBannerSlider.wp-block-gallery'
    ).length > 0,
    document.querySelectorAll(
      '.ListProductsSlider .ListProductsSlider__container .wp-block-group__inner-container'
    ).length > 0,
    document.querySelectorAll(
      '.VeterinaryAuthors .VeterinaryAuthors__vet-cards-container'
    ).length > 0,
    document.querySelectorAll(
      '.EditorsPickWrapper--home .EditorsPick--list-mobile'
    ).length > 0,
    document.querySelectorAll(
      '.ExpertsPicks--home .ExpertsPicksGrid__content--mobile .PostsGrid'
    ).length > 0,
    Array.from(document.querySelectorAll('.vst-slideshow')).length > 0,
    Array.from(
      document.querySelectorAll(
        '.CareCredit .CareCredit__care-tools .wp-block-group.items > .wp-block-group__inner-container'
      )
    ).length > 0,
  ]

  if (sliderConditions.some(Boolean)) {
    import(
      /* webpackChunkName: "tiny-slider-module" */ 'tiny-slider/src/tiny-slider'
    ).then((module) => {
      const { tns } = module

      DefaultSlider(tns)
      BlockSlider(tns)
      FeaturedContentSlider(tns)
      ShowPostsGroupSlider(tns)
      ProductInfusionMultipleSlider(tns)
      ModalGalleryArticle(tns)
      PromoBanner(tns)
      ListProductsSlider(tns)
      VeterinaryAuthors(tns)
      EditorsPickHome(tns)
      ExpertsPicksHome(tns)
      FeaturedContentHome(tns)
      VetstreetSlideshow(tns)
      CareTools(tns)
    })
  }
}
